import React from 'react'
import holidays from "./holiday1.PNG";
import "./holiday.css"

const HolidayCalendar = () => {
  return (
    <div>
        <div className='holiday'>

        <img src={holidays} />
        </div>
      
    </div>
  )
}

export default HolidayCalendar
